<template>
    <a
        @click.prevent="openAuthWindow"
        :class="['button', 'full-width', 'flex-container', 'align-middle', 'social-btn', `${authProvider.id}-provider`]"
        :style="{ backgroundColor: authProvider.backgroundColor, border: buttonBorder}"
    >
        <div class="login-social-icon">
            <span v-html="socialIcon"></span>
        </div>
        <span class="login-social-text" :style="{ color: authProvider.textColor }">Continue with {{ authProvider.name }}</span>
    </a>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import createPopup from '@/utils/popup-window'
import {Prop} from 'vue-property-decorator'
import {providers, AuthProvider} from '@/front/auth-providers'
import UserModule from '@/stores/modules/user'
import { getModule } from 'vuex-module-decorators'
import { AuthStatus } from '@/utils/types';
import User from '@/models/user';
import { Icon } from '@/front/icons';
import CartModule from '@/stores/modules/cart';


@Component
export default class SocialLoginButton extends Vue {
    @Prop(String) readonly provider!: string;
    userModule!: UserModule;
    cartModule!: CartModule;

    public created(): void {
        this.userModule = getModule(UserModule, this.$store);
        this.cartModule = getModule(CartModule, this.$store);

        (window as any).setAuthResponse = (response: string) => {
            this.userModule.setAuthStatus(response as AuthStatus);
            if (response === AuthStatus.LOGGED_IN || response === AuthStatus.NEW_USER || response === AuthStatus.NEW_PROVIDER) {
                this.userModule.fetchUser();
                this.userModule.closeLoginModal();
                this.cartModule.setRegistrationError(false);
            }
        }
    }

    get authProvider(): AuthProvider | undefined {
        return providers.find(authProvider => authProvider.id === this.provider);
    }

    get socialIcon() {
        const provider = this.provider.toUpperCase();
        return (<any>Icon)[provider + '_LOGIN'];
    }

    get buttonBorder() {
        if (this.authProvider) {
            if (this.authProvider.backgroundColor === '#fff') return '1px solid #d4d8e1';
        }
    }

    public openAuthWindow(): void {
        if (this.authProvider) {
            this.userModule.setAuthStatus(null);
            createPopup(this.authProvider.route, this.authProvider.popupHeight, this.authProvider.popupWidth);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.social-btn {
    padding: 10.75px 10.75px;
}
.login-social-icon {
    width: 30px;
    display: inline-block;
    margin-right: 8px;
    position: relative;
    top: 2px;
}

.login-social-text {
    vertical-align: super;
}

</style>